import(/* webpackMode: "eager" */ "/vercel/path0/Website/components/home/BankAccountBanner.jsx")